<template>
  <v-card class="card pa-6 mx-auto" elevation="1">
    <div class="px-2 d-flex" style="justify-content: center">
      <h2 class="justify-center">
        <span class="title-2">
          Tem certeza que deseja<br />
          <strong>
            {{ title }}
          </strong>
          esse pedido?
        </span>
      </h2>
    </div>

    <div class="my-6 mx-2 px-1 d-flex flex-column justify-center align-center">
      <span class="label py-2">
        Certifique-se que o status selecionado está correto pois ao mudar não é possível
        voltar atrás
      </span>
    </div>

    <div>
      <v-row class="d-flex ma-0 pa-0">
        <v-col cols="12" class="d-flex justify-center">
          <v-btn outlined class="cancelBtn mr-2" @click="close" :loading="loading">
            <span class="cancel">Cancelar</span>
          </v-btn>

          <v-btn class="okBtn mr-2" @click="action()" :loading="loading">
            <span class="yep">Sim</span>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<style scoped>
.yep {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.15px;

  color: #ffffff;
}
.cancel {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;

  color: #2d3038;
}
.card {
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 11px;
}

.cancelBtn {
  width: 200px !important;
  height: 50px !important;

  border: 2px solid #2d3038 !important;
  box-sizing: border-box;
  border-radius: 6px;
}

.okBtn {
  width: 200px !important;
  height: 50px !important;

  background: #2d3038 !important;
  border-radius: 6px;
}

.label {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.15px;

  color: #232021;
}

@media (max-width: 600px) {
  .select-type {
    width: 50% !important;
  }
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import Vue from "vue";

export default {
  name: "AprovalModal",

  props: {
    title: String,
    order: Object,
  },

  data: () => ({
    loading: false,
    excelDialog: "",
    apiService: new ApiService(),
  }),

  methods: {
    close() {
      this.$emit("close");
    },

    action() {
      this.$emit("action");
    },

    // async submit() {
    //   this.loading = true;
    //   const model = {};

    //   await this.apiService
    //     .post("order/edit", model)
    //     .then((response) => {
    //       this.loading = false;

    //       Vue.$globalEvent.$emit("onFlashMessage", {
    //         type: "sucess",
    //         title: "Edição feita com sucesso!.",
    //         message: "",
    //         trace: null,
    //       });
    //       this.close();
    //     })
    //     .catch((err) => {
    //       Vue.$globalEvent.$emit("onFlashMessage", {
    //         type: "error",
    //         title: "Erro ao atualizar o status do pedido.",
    //         message: "",
    //         trace: null,
    //       });
    //       this.loading = false;
    //     });
    // },
  },
};
</script>
